// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ErrorComponent_wrapper__PplDV","title":"ErrorComponent_title__yXc7f","text":"ErrorComponent_text__ZxXnj"};